import { render, staticRenderFns } from "./AgregarButton2.vue?vue&type=template&id=0a6c4292&scoped=true&"
import script from "./AgregarButton2.vue?vue&type=script&lang=ts&"
export * from "./AgregarButton2.vue?vue&type=script&lang=ts&"
import style0 from "./AgregarButton2.vue?vue&type=style&index=0&id=0a6c4292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6c4292",
  null
  
)

export default component.exports